import { render, staticRenderFns } from "./OpenCartAdd.vue?vue&type=template&id=fbd2ae8e&scoped=true&"
import script from "./OpenCartAdd.vue?vue&type=script&lang=js&"
export * from "./OpenCartAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd2ae8e",
  null
  
)

export default component.exports